import { Divider as AntdDivider, DividerProps as AntdDividerProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface DividerProps extends AntdDividerProps {}

export const dividerPrefixCls = `${CMP_PREFIX}-divider`;

export const Divider = ({ ...props }: DividerProps) => {
  return <AntdDivider {...props} />;
};
